<template>
  <div class="list-container col-12">
    <div class="list-card" :class="{ 'my-list': list.owner_id == userId }">
      <div class="title-container" @click="$router.push('/lists/' + list.id)">
        <div class="title bold">
          {{ list.title }}
        </div>
        <div class="list-card-info">
          <div class="ideas-counter" v-if="!newIdeasTagInList">
            {{ ideasCountText }}
          </div>
          <tag-text :title="'New ideas'" v-if="newIdeasTagInList"></tag-text>
          <members-circles :membersToShow="membersToShow"></members-circles>
        </div>
      </div>
      <div class="list-menu-icon">
        <b-dropdown
          variant="link"
          right
          text="Right align"
          toggle-class="text-decoration-none"
          no-caret
          lazy
        >
          <template v-slot:button-content>
            <span class="icon-three-dots"></span>
          </template>

          <b-dropdown-item v-if="list.owner_id == userId">
            <span class="change-title" @click="openUpdateListTitleModal"
              >Edit</span
            >
          </b-dropdown-item>
          <b-dropdown-item v-if="list.owner_id === userId && list.status === 'active'">
            <span class="conclude" @click="concludeList">Conclude</span>
          </b-dropdown-item>
          <b-dropdown-item v-if="list.owner_id === userId && list.status === 'concluded'">
            <span class="reopen" @click="reopenSession">Reopen</span>
          </b-dropdown-item>
          <b-dropdown-item v-if="list.owner_id === userId">
            <span class="archive" @click="archiveList">Delete</span>
          </b-dropdown-item>
          <b-dropdown-item v-if="list.owner_id !== userId">
            <span class="leave" @click="leaveList">Leave</span>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import bus from "../../bus";
import api from "../../api";

import getMembersToShow from "../../mixins/getMembersToShow";
import MembersCircles from "./MembersCircles";
import TagText from "../shared/TagText";

import updateList from "../../gql/lists/updateList.gql";
import updateUserLists from "../../gql/lists/updateUserLists.gql";
import reopenSession from "@/gql/lists/reopenSession.gql";

export default {
  components: {
    MembersCircles,
    TagText,
  },
  data() {
    return {};
  },
  computed: {
    membersToShow: function () {
      let membersToShow = [];
      for (let i = 0; i < this.list.users_lists.length; i++) {
        membersToShow.push(this.list.users_lists[i].user);
      }
      return this.getMembersToShow(membersToShow);
    },
    ideasCountText: function () {
      let ideasCount = this.list.ideas_lists_aggregate.aggregate.count;
      if (ideasCount == 1) {
        return ideasCount.toString() + " idea";
      } else {
        return ideasCount.toString() + " ideas";
      }
    },
    newIdeasTagInList: function () {
      for (let i = 0; i < this.list.ideas_lists.length; i++) {
        if (
          this.list.ideas_lists[i].idea.evaluations_aggregate.aggregate.count ==
          0
        ) {
          return true;
        }
      }
      return false;
    },
  },
  methods: {
    archiveList: function () {
      if(!confirm('Are you sure you want to delete this brainstorming session?')) return;
      const id = this.list.id;
      const status = "archived";
      const title = this.list.title;

      this.$apollo
        .mutate({
          mutation: updateList,
          variables: {
            id,
            status,
            title,
          },
        })
        .then(() => {
          api.createEventTracking(
            "list-archived",
            "list-archived",
            this.$store.state.user.id,
            true
          );
        })
        .catch(function (error) {
          this.$rollbar.error(error);
          alert("Could not delete the brainstorming session. Please try again later.");
        });
    },
    leaveList: function () {
      const list_id = this.list.id;
      const user_id = this.$store.state.user.id;

      this.$apollo
        .mutate({
          mutation: updateUserLists,
          variables: {
            list_id,
            user_id,
          },
        })
        .then(() => {
          api.createEventTracking(
            "list-left",
            "list-left",
            this.$store.state.user.id,
            true
          );
        })
        .catch(function (error) {
          this.$rollbar.error(error);
          alert("There was an error removing you from the list. Please try again later.");
        });
    },
    openUpdateListTitleModal: function () {
      bus.$emit("open-modal", "UpdateListTitleModal", "list", this.list);
    },
    concludeList: function() {
      bus.$emit("open-modal", "ConcludeSessionModal", "session", this.list);
    },
    async reopenSession() {
      const { data } = await this.$apollo.mutate({
        mutation: reopenSession,
        variables: {
          listId: this.list.id,
        }
      }).catch((e) => {
        this.$rollbar.error(e);
        alert("There was an error reopening the session. Please try again later.");
      });
      if(data) {
        alert("The brainstorming session has been reopened.");
      } else {
        alert("There has been a problem while trying to reopen the brainstorming session. Please try again later.");
      }
    },
  },
  props: {
    list: {
      type: Object,
      required: true,
    },
    userId: {
      type: String,
      required: true,
    },
  },
  mixins: [getMembersToShow],
};
</script>

<style scoped lang="scss">
@use '@/styles/theme.scss';

.list-container {
  display: inline-block;
}

.list-card {
  position: relative;
  width: 100%;
  background-color: theme.$white-background;
  margin-bottom: 10px;
  padding: 12px 16px 16px 16px;
  border-top: 4px solid theme.$text-placeholder;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.my-list {
  border-top: 4px solid theme.$accent-color;
}

.list-card .title {
  width: calc(100% - 20px);
}

.list-card .title a {
  color: theme.$title-color;
}

.list-card .list-card-info {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-top: 15px;
  align-items: center;
}

.list-card .ideas-counter {
  display: inline-block;
  font-size: 12px;
  color: theme.$text-placeholder;
  font-weight: 600;
}

.list-card div.list-menu-icon {
  color: theme.$text-secondary-color;
  position: absolute;
  right: 0px;
  top: calc(50% - 40px);
}

.list-card .member-counter {
  flex-grow: 1;
}

.archive,
.leave {
  color: theme.$text-danger !important;
}

.list-menu-icon .btn-group > .btn:focus,
.list-menu-icon .btn-group > .btn:hover {
  z-index: 0;
}

.list-menu-icon span.icon-three-dots {
  color: theme.$text-secondary-color;
  font-size: 24px;
}

@media (min-width: 768px) {
  .list-card .title {
    white-space: nowrap;
    overflow: hidden;
    display: block;
    text-overflow: ellipsis;
  }
}
</style>